import { Button, Stack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { HomeOptionsLink } from '../../../constants/hom-options';

const MotionedStack = motion(Stack);

const Navbar = () => {
	const [searchParams] = useSearchParams();
	const param = searchParams.get('ca');
	const [show, setShow] = useState(false);

	React.useEffect(() => {
		const handler = (e, a) => {
			if (window.scrollY > 29 && show === false) {
				setShow(true);
			}
			if (window.scrollY < 29 && show) {
				setShow(false);
			}
		};
		
		window.addEventListener('scroll', handler);
		return () => {
			window.removeEventListener('scroll', handler);
		};
	}, [setShow, show]);

	return (
		<>
			<MotionedStack
				zIndex={1}
				direction={'row'}
				borderRadius={'full'}
				mx={'auto'}
				maxWidth={['361px', '461px', '565px']}
				w={'full'}
				bg={'white'}
				position={'fixed'}
				bottom={show ? '29px' : '-46px'}
				initial={{
					bottom: show ? '29px' : '-46px',
				}}
				animate={{
					bottom: show ? '29px' : '-46px',
				}}
				left={'0'}
				right={'0'}
				height={'46px'}
				alignItems={'center'}
				p={'5px'}
				overflow={'scroll'}
				sx={{
					MsOverflowStyle: 'none' /* IE and Edge */,
					scrollbarWidth: 'none' /* Firefox */,
					'&::-webkit-scrollbar': {
						display: 'none',
					},
				}}
				spacing={[0, 1]}
			>
				{HomeOptionsLink.map((item, key) => {
					return (
						<Button
							sx={{
								px: ['10px', '20px'],
							}}
							fontSize={['8px', '10px', '12px']}
							key={key}
							isActive={param === item.title}
							display={'flex'}
							as={Link}
							to={`/${item.href}`}
						>
							{item.title}
						</Button>
					);
				})}
			</MotionedStack>
		</>
	);
};

export default Navbar;
